import type { KyInstance } from "ky";

interface TotalCallCountResponse {
    callCount: number;
}

export const getTotalCallCount = async (
    client: KyInstance,
    { start, end }: { start: string; end: string },
): Promise<TotalCallCountResponse> => {
    return await client.get(`v1/metrics/calls?start=${start}&end=${end}`, { retry: 0 }).json<TotalCallCountResponse>();
};
